/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Move16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            d="M5.5 13l5 .02a.5.5 0 01.354.853l-2.502 1.98a.499.499 0 01-.707 0l-2.499-2A.5.5 0 015.5 13zM14 9a1 1 0 010 2H2a1 1 0 010-2h12zm0-4a1 1 0 010 2H2a1 1 0 110-2h12zM8 0c.127 0 .255.05.352.146l2.502 1.981a.499.499 0 01-.354.854L5.5 3a.5.5 0 01-.354-.854l2.499-2A.499.499 0 018 0z"
        />
    </AccessibleSVG>
);

export default Move16;
